import React from "react";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export const Countdown = ({ dueDate, className }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    const [end, setEnd] = useState(false);

    useEffect(() => {
        const updateCountdown = () => {
            const now = new Date();
            const diff = dueDate.getTime() - now.getTime();

            if (diff <= 0) {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
                setEnd(true);
                return;
            }

            const totalSeconds = Math.floor(diff / 1000);
            const days = Math.floor(totalSeconds / 86400);
            const hours = Math.floor((totalSeconds % 86400) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            setTimeLeft({ days, hours, minutes, seconds });
        };

        updateCountdown(); // Initial call
        const interval = setInterval(updateCountdown, 1000);
        return () => clearInterval(interval); // Cleanup
    }, [dueDate]);

    return (
        <div className={twMerge("grid grid-cols-4 gap-5 text-center", end && "!text-error", className)}>
            <div className="flex-center">
                <span className="countdown font-mono text-5xl">
                    <span style={{ "--value": timeLeft.days }}></span>
                </span>
                <span className="text-sm opacity-80">
                    days
                </span>
            </div>
            <div className="flex-center">
                <span className="countdown font-mono text-5xl">
                    <span style={{ "--value": timeLeft.hours }}></span>
                </span>
                <span className="text-sm opacity-80">
                    hours
                </span>
            </div>
            <div className="flex-center">
                <span className="countdown font-mono text-5xl">
                    <span style={{ "--value": timeLeft.minutes }}></span>
                </span>
                <span className="text-sm opacity-80">
                    min
                </span>
            </div>
            <div className="flex-center">
                <span className="countdown font-mono text-5xl">
                    <span style={{ "--value": timeLeft.seconds }}></span>
                </span>
                <span className="text-sm opacity-80">
                    sec
                </span>
            </div>
        </div >
    );
};
// <div className="flex gap-2 text-xl">
//     <div>
//         <span className="countdown font-mono text-2xl">
//             <span style={{ "--value": timeLeft.days }}></span>
//         </span>
//         days
//     </div>
//     <div>
//         <span className="countdown font-mono text-2xl">
//             <span style={{ "--value": timeLeft.hours }}></span>
//         </span>
//         hrs
//     </div>
//     <div>
//         <span className="countdown font-mono text-2xl">
//             <span style={{ "--value": timeLeft.minutes }}></span>
//         </span>
//         min
//     </div>
//     <div>
//         <span className="countdown font-mono text-2xl">
//             <span style={{ "--value": timeLeft.seconds }}></span>
//         </span>
//         sec
//     </div>
// </div>

export default Countdown;
